// extracted by mini-css-extract-plugin
export var active = "Recipe-module--active--rhNdm";
export var content = "Recipe-module--content--MjKtL";
export var imageWrapper = "Recipe-module--imageWrapper--6yWBV";
export var label = "Recipe-module--label--wq+6s";
export var list = "Recipe-module--list--nB5fz";
export var recipeFor = "Recipe-module--recipeFor--jSOlW";
export var tab = "Recipe-module--tab--wVD2H";
export var text = "Recipe-module--text--d3HW+";
export var wrapper = "Recipe-module--wrapper--OmY5T";